// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "fa7b42cdb7d986e139d5" + ".js";
};